// extracted by mini-css-extract-plugin
module.exports = {"form":"login_form-module--form--1q3ML"};